/* ALLTRENDS — motorul de personalizare comerciala (at-perso).
   ==========================================================================================
   CE FACE: decide CE produs se arata fiecarui vizitator si, mai important, DE CE. Fiecare
   card afisat de sistemul asta are un motiv real, calculat din ce a facut chiar el:
   ce a deschis, ce are in cos, ce a pus la favorite, ce categorie rasfoieste.

   CE NU FACE, intentionat:
     · nu inventeaza „X persoane cumpara acum\", nu numara vanzari, nu pune procente scoase
       din burta. Magazinul are 4 comenzi in total (masurat), toate de la acelasi client —
       deci ORICE afirmatie de tip „altii au cumparat\" ar fi falsa;
     · nu afiseaza note/recenzii (sunt fabricate — verificat: acelasi text semnat de doua
       persoane diferite pe acelasi produs, scrise in bloc in 90 de secunde);
     · nu promite reduceri pe segmente (VIP7 are 1 client din 4) decat pe ramura logata.

   PE CE SE SPRIJINA (toate existau deja in tema, nu le rescriu):
     window.AT_ISTORIC.citeste()   -> produsele deschise de vizitator, recent-intai
     window.AT_ISTORIC.colectii()  -> categoriile lui, cu scor ponderat pe recenta
     window.AT_CREIER.stare()      -> cosul real + sfaturile calculate pe praguri reale
     evenimentul `at:creier`       -> se emite la orice schimbare de cos (carlig deja pus)
     localStorage `square-wishlist`-> favoritele (lista de handle-uri)
     `/products/<h>?view=at-card`  -> cardul REAL, cu cos AJAX si favorite functionale

   ⚠️ NU pun un al patrulea carlig peste window.fetch. Sunt deja trei in pagina
      (at-store-js, at-cart-skin, at-creier) si fiecare se inlantuie peste precedentul.
      Ascult evenimentul, nu interceptez cererile.
   ========================================================================================== */
(function () {
  'use strict';
  if (window.AT_PERSO) return;

  /* ======================================================================================
     0. UTILITARE
     ====================================================================================== */

  function lei(bani) {
    var n = (Math.round(bani) / 100).toFixed(2).replace('.', ',');
    return n + ' lei';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function handleDinUrl(u) {
    var m = String(u || '').split('?')[0].match(/\/products\/([^/#?]+)/);
    return m ? m[1] : '';
  }

  function favorite() {
    try { var a = JSON.parse(localStorage.getItem('square-wishlist') || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }

  function istoric() {
    try { return (window.AT_ISTORIC && window.AT_ISTORIC.citeste()) || []; } catch (e) { return []; }
  }

  /* Colectii prea generice ca sa insemne o preferinta. „Noutati\" contine practic tot
     catalogul, „Pachet AllTrends\" e un bazin de lucru — daca le-as lasa inauntru, categoria
     „preferata\" a oricui ar iesi mereu aceeasi.
     ⚠️ Aceeasi lista e hardcodata in at-creier, at-hero-smart si at-home-reco, cu continut
     DIFERIT (doua au 'top-vanzari', a treia nu). Aici o tin completa; daca o schimbi, uita-te
     si acolo, altfel aceeasi vizita produce categorii diferite in sectiuni diferite. */
  var GENERICE = {
    'noutati': 1, 'pachet-alltrends': 1, 'super-oferte': 1, 'flash-deals': 1,
    'top-vanzari': 1, 'all': 1, 'lichidare': 1
  };

  function categorii() {
    var c = [];
    try { c = (window.AT_ISTORIC && window.AT_ISTORIC.colectii()) || []; } catch (e) { c = []; }
    return c.filter(function (x) { return x && x.handle && !GENERICE[x.handle]; });
  }

  /* ======================================================================================
     1. COSUL — citit direct din /cart.js, reimprospatat pe evenimentul temei
     ====================================================================================== */

  var cosCache = null, cosCerere = null;

  function cos(fortat) {
    if (!fortat && cosCache) return Promise.resolve(cosCache);
    if (cosCerere) return cosCerere;
    var url = (window.routes && window.routes.cart_url) || '/cart';
    cosCerere = fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [], item_count: 0, total_price: 0 }; })
      .catch(function () { return { items: [], item_count: 0, total_price: 0 }; })
      .then(function (c) { cosCache = c; cosCerere = null; return c; });
    return cosCerere;
  }

  document.addEventListener('at:creier', function () {
    cos(true).then(function () { emite('at-perso:date'); });
  });

  function emite(nume, detaliu) {
    try { document.dispatchEvent(new CustomEvent(nume, { detail: detaliu || null })); } catch (e) {}
  }

  /* ======================================================================================
     2. CARDURI REALE, LA CERERE
     Aduc markup-ul de la `/products/<handle>?view=at-card`, care randeaza acelasi
     `card-product.liquid` ca peste tot in magazin. Asa cosul AJAX, favoritele, imaginile
     si regulile de pret raman EXACT cele ale temei — nu construiesc o a doua copie a
     cardului in JavaScript, care s-ar departa de original la prima modificare.
     ====================================================================================== */

  var CACHE_CHEIE = 'at_perso_card_v1';
  var CACHE_VIATA = 30 * 60 * 1000;   /* 30 min: preturile se pot schimba, nu tin mai mult */
  var memorie = {};

  function cacheCiteste() {
    try {
      var o = JSON.parse(sessionStorage.getItem(CACHE_CHEIE) || '{}');
      return (o && typeof o === 'object') ? o : {};
    } catch (e) { return {}; }
  }

  function cacheScrie(o) {
    try { sessionStorage.setItem(CACHE_CHEIE, JSON.stringify(o)); } catch (e) { /* cota plina */ }
  }

  function cardHTML(handle) {
    if (!handle) return Promise.reject('fara handle');
    if (memorie[handle]) return memorie[handle];

    var disc = cacheCiteste();
    var v = disc[handle];
    if (v && (Date.now() - v.t) < CACHE_VIATA && v.h) {
      memorie[handle] = Promise.resolve(v.h);
      return memorie[handle];
    }

    memorie[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=at-card', {
      headers: { Accept: 'text/html' }
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (h) {
        if (h.indexOf('alt-card') < 0) throw new Error('raspuns fara card');
        var d = cacheCiteste();
        d[handle] = { t: Date.now(), h: h };
        /* Tin cel mult 24 de carduri; peste asta sessionStorage-ul se umple si arunca. */
        var chei = Object.keys(d);
        if (chei.length > 24) {
          chei.sort(function (a, b) { return d[a].t - d[b].t; });
          for (var i = 0; i < chei.length - 24; i++) delete d[chei[i]];
        }
        cacheScrie(d);
        return h;
      })
      .catch(function (e) { delete memorie[handle]; throw e; });

    return memorie[handle];
  }

  /* ======================================================================================
     2b. CITIREA UNEI VEDERI PROPRII (`?view=…`)
     ⚠️ CAPCANA, masurata pe 2026-08-12 si greu de prins fiindca esueaza TACUT:
        daca ceri `/collections/x?view=at-set` cu antetul `Accept: application/json`,
        Shopify IGNORA complet `?view=` si raspunde cu API-ul lui nativ —
        `{"collection":{...}}` in loc de lista mea. Status 200, JSON perfect valid, alte date.
        Simptomul a fost `j.filter is not a function`, adica un obiect in loc de tablou.
        Deci: NU trimite Accept pe vederile proprii. Cere text si parseaza singur.
     ====================================================================================== */

  var vederiInCurs = {};

  function vedereJSON(url) {
    /* ⚠️ Cache pe URL, in memorie. Fara el, cele trei sectiuni ale sistemului cer
       SIMULTAN aceeasi lista: masurat pe prima pagina, 3 cereri identice catre
       `/collections/<categoria-preferata>?view=at-set`. Cheia e ca promisiunea se pune in
       cache INAINTE sa se rezolve, deci apelurile care vin intre timp se ataseaza la
       aceeasi cerere, nu pornesc alta. */
    if (vederiInCurs[url]) return vederiInCurs[url];
    vederiInCurs[url] = fetch(url)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); })
      .catch(function (e) { delete vederiInCurs[url]; throw e; });
    return vederiInCurs[url];
  }

  /* ======================================================================================
     2c. ORDINEA DE ALEGERE
     Blocul principal are prima optiune asupra produselor: el arata cele mai puternice
     motive (cosul, ce a vazut, favoritele). Rafturile de mai jos aleg din ce a ramas.
     Fara asta, raftul care se initializeaza primul rezerva TOT (185 de link-uri de produs
     erau deja pe pagina) si blocul principal ramanea pe rezerva de server — exact bug-ul
     gasit la prima probă.
     Daca pagina n-are bloc principal, promisiunea se rezolva singura dupa 2,5 s.
     ====================================================================================== */

  var rezolvaHub;
  var hubGata = new Promise(function (res) { rezolvaHub = res; });
  setTimeout(function () { rezolvaHub('expirat'); }, 2500);

  /* ======================================================================================
     3. DEDUPLICARE GLOBALA
     Un produs care apare la „Ai uitat in cos\" nu are voie sa reapara imediat la
     „Recomandat pentru tine\". Registrul e unul singur pentru toata pagina, iar
     ordinea de rezervare da prioritatea (cos > vazut recent > set > interes > popular).
     ====================================================================================== */

  var rezervate = Object.create(null);

  function rezerva(handle) {
    if (!handle) return false;
    if (rezervate[handle]) return false;
    rezervate[handle] = true;
    return true;
  }

  function eRezervat(h) { return !!rezervate[h]; }

  /* Produsele deja randate de ALTE sectiuni ale temei (Flash Deals, Top vanzari, grile).
     Fara pasul asta, „recomandat pentru tine\" ar repeta ce e deja pe ecran mai jos. */
  function marcheazaPagina(fara) {
    /* ⚠️ Marcheaza doar VECINATATEA, nu toata pagina. Prima varianta marca toate
       link-urile de produs din document. Masurat pe prima pagina: 185 din 185 de produse
       ajungeau rezervate, fiindca exista deja caruselul fc_antistres cu 25 de produse din
       EXACT categoria preferata a vizitatorului. Rezultat: raftul "Recomandate in functie
       de interesul tau" nu mai avea din ce alege si ramanea pe rezerva, adica fix invers
       decat scopul lui.

       Cerinta reala e "acelasi produs sa nu apara in 3-4 sectiuni CONSECUTIVE", nu
       "niciodata de doua ori in pagina". Un produs care reapare la 3000 px mai jos, intr-un
       carusel de categorie, nu deranjeaza pe nimeni. Deci zona de dedup e:
         - toate sectiunile sistemului de personalizare (ele chiar stau una langa alta);
         - plus sectiunea dinainte si cea de dupa.
       Cardurile PROPRII ale sectiunii care intreaba nu se marcheaza: le inlocuieste oricum. */
    /* ⚠️ Ce e deja în coș nu se recomandă niciodată, indiferent de pagină. Fără regula asta,
       raftul de pe /cart recomanda exact produsele din coș: secțiunile de acolo nu sunt vecine
       cu lista de produse, deci scanarea pe vecinătate nu le prindea. Citim din cache-ul
       coșului, care e cald fiindcă motorul cere `/cart.js` la pornire. */
    if (cosCache && cosCache.items) {
      for (var q = 0; q < cosCache.items.length; q++) {
        var hc = cosCache.items[q] && cosCache.items[q].handle;
        if (hc) rezervate[hc] = true;
      }
    }

    var zone = [];
    var proprii = document.querySelectorAll('.at-perso-hub, .at-perso-bundle, .at-perso-raft');
    for (var i = 0; i < proprii.length; i++) zone.push(proprii[i]);

    var s = (fara && fara.closest) ? fara.closest('.shopify-section') : null;
    if (s) {
      if (s.previousElementSibling) zone.push(s.previousElementSibling);
      if (s.nextElementSibling) zone.push(s.nextElementSibling);
    }

    for (var z = 0; z < zone.length; z++) {
      if (fara && zone[z].contains(fara)) continue;
      var a = zone[z].querySelectorAll('a[href*="/products/"]');
      for (var j = 0; j < a.length; j++) {
        var h = handleDinUrl(a[j].getAttribute('href'));
        if (h) rezervate[h] = true;
      }
    }
  }

  /* ======================================================================================
     4. MODELUL DE SCOR — determinist, fara AI, fara server
     Fiecare pondere raspunde la „cat de tare arata semnalul asta ca omul vrea produsul\".
     Ordinea conteaza mai mult decat cifrele exacte; cifrele sunt alese ca sa nu se poata
     inversa: un produs din cos bate orice combinatie de semnale slabe.
     ====================================================================================== */

  var G = {
    cos: 100,          /* e in cos ACUM — intentie confirmata */
    favorit: 60,       /* pus la favorite — intentie declarata */
    vazutRecent: 42,   /* a deschis pagina produsului */
    recenta: 18,       /* bonus care scade cu pozitia in istoric */
    categorie: 22,     /* apartine categoriei pe care o rasfoieste */
    disponibil: 10,    /* in stoc (un produs epuizat nu are ce cauta intr-o recomandare) */
    redus: 6           /* are pret taiat REAL (compare_at > pret) */
  };

  function scor(p, ctx) {
    var s = 0;
    if (ctx.inCos[p.h]) s += G.cos;
    if (ctx.favorite.indexOf(p.h) >= 0) s += G.favorit;
    var poz = ctx.pozIstoric[p.h];
    if (poz != null) s += G.vazutRecent + G.recenta / (1 + poz * 0.4);
    if (p.categorii) {
      for (var i = 0; i < p.categorii.length; i++) {
        var sc = ctx.scorCat[p.categorii[i]];
        if (sc) s += G.categorie * Math.min(1, sc / 2);
      }
    }
    if (p.disp !== false) s += G.disponibil;
    if (p.pv && p.p && p.pv > p.p) s += G.redus;
    return s;
  }

  function context() {
    return cos().then(function (c) {
      var inCos = {}, ist = istoric(), pozIstoric = {}, scorCat = {};
      (c.items || []).forEach(function (it) { inCos[it.handle] = it; });
      ist.forEach(function (x, i) { if (x && x.handle) pozIstoric[x.handle] = i; });
      categorii().forEach(function (x) { scorCat[x.handle] = x.scor; });
      return {
        cos: c, inCos: inCos, istoric: ist, pozIstoric: pozIstoric,
        favorite: favorite(), scorCat: scorCat, categorii: categorii()
      };
    });
  }

  /* ======================================================================================
     5. PICTOGRAME (inline, ca sa nu mai fie o cerere de retea pentru 6 forme)
     ====================================================================================== */

  var IC = {
    stea: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l2.7 5.5 6 .9-4.3 4.2 1 6-5.4-2.8-5.4 2.8 1-6L3.3 9.4l6-.9z"/></svg>',
    ochi: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6-10-6-10-6z"/><circle cx="12" cy="12" r="2.6"/></svg>',
    cos: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.2 11.2a1 1 0 0 0 1 .8h9a1 1 0 0 0 1-.8L20 7H6"/></svg>',
    coroana: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8l4 3 5-6 5 6 4-3-2 11H5z"/></svg>',
    sageata: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg>',
    inchide: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    puzzle: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 3h4v3a2 2 0 1 0 4 0h3v4h-3a2 2 0 1 0 0 4h3v4h-4a2 2 0 1 0-4 0H6v-4a2 2 0 1 1 0-4H3V6h3a2 2 0 1 0 4 0z"/></svg>',
    inima: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.6-9.3-9C1.2 8 3 4.5 6.2 4.5c1.9 0 3.2 1.1 3.8 2 .6-.9 1.9-2 3.8-2 3.2 0 5 3.5 3.5 6.5C19 15.4 12 20 12 20z"/></svg>',
    cadou: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 11h18v9H3zM3 7h18v4H3zM12 7v13M12 7S9.5 3 7.5 4.2 9 7 12 7zM12 7s2.5-4 4.5-2.8S15 7 12 7z"/></svg>',
    persoana: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="3.4"/><path d="M4.5 20c1-4 4-6 7.5-6s6.5 2 7.5 6"/></svg>'
  };

  /* Motivele contextuale. Textul spune ADEVARUL despre de ce e acolo produsul. */
  var MOTIVE = {
    reco: { et: 'Recomandat pentru tine', ic: IC.stea, cls: '' },
    vazut: { et: 'Vizualizat recent', ic: IC.ochi, cls: 'atp-why--vazut' },
    cosul: { et: 'Ai uitat în coș', ic: IC.cos, cls: 'atp-why--cos' },
    vip: { et: 'Preț exclusiv pentru tine', ic: IC.coroana, cls: 'atp-why--vip' },
    favorit: { et: 'E la favoritele tale', ic: IC.inima, cls: '' },
    popular: { et: 'Populare acum', ic: IC.stea, cls: '' }
  };

  /* ======================================================================================
     6. MONTAREA UNUI CARD INTR-UN SLOT
     ====================================================================================== */

  function pastila(motiv) {
    var m = MOTIVE[motiv] || MOTIVE.reco;
    return '<span class="atp-why ' + m.cls + '">' + m.ic + esc(m.et) + '</span>';
  }

  function pune(slot, html, motiv, optiuni) {
    optiuni = optiuni || {};
    var gazda = document.createElement('div');
    gazda.innerHTML = html;

    var card = gazda.querySelector('.alt-card');
    if (!card) return false;

    /* Pastila „de ce\" merge PRIM copil in corpul cardului, exact ca in macheta:
       sub poza, deasupra titlului. */
    var corp = card.querySelector('.alt-card__body');
    if (corp) corp.insertAdjacentHTML('afterbegin', pastila(motiv));

    /* Cardul din cos primeste alt CTA — omul are deja produsul in cos, „Adauga in cos\"
       ar fi un buton care nu spune adevarul. */
    if (optiuni.cta) {
      var zona = card.querySelector('.alt-card__cta');
      if (zona) {
        zona.innerHTML = '<a class="alt-card__btn" href="' + esc(optiuni.cta.url) + '">' +
          IC.cos + '<span class="alt-card__btn-full">' + esc(optiuni.cta.text) + '</span>' +
          '<span class="alt-card__btn-short">' + esc(optiuni.cta.scurt || optiuni.cta.text) + '</span></a>';
      }
    }

    /* × de renuntare, doar pe cardul de cos (ca in macheta). E o functie reala:
       ascunde cardul pentru sesiunea curenta si trece la urmatorul motiv. */
    if (optiuni.inchidere) {
      var sus = card.querySelector('.alt-card__top');
      if (sus) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'atp-inchide';
        b.setAttribute('aria-label', 'Nu-mi mai arăta acest produs');
        b.innerHTML = IC.inchide;
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          respinge(optiuni.inchidere);
          slot.dispatchEvent(new CustomEvent('at-perso:respins', { bubbles: true, detail: optiuni.inchidere }));
        });
        sus.appendChild(b);
      }
    }

    slot.innerHTML = '';
    while (gazda.firstChild) slot.appendChild(gazda.firstChild);
    slot.removeAttribute('data-gol');
    return true;
  }

  /* Produse respinse de client — se tin pe sesiune, nu pe veci: a doua zi poate s-a razgandit. */
  var RESP = 'at_perso_respinse_v1';
  function respinse() {
    try { var a = JSON.parse(sessionStorage.getItem(RESP) || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function respinge(h) {
    var a = respinse();
    if (a.indexOf(h) < 0) { a.push(h); try { sessionStorage.setItem(RESP, JSON.stringify(a)); } catch (e) {} }
  }

  /* ======================================================================================
     7. API PUBLIC
     ====================================================================================== */

  window.AT_PERSO = {
    lei: lei, esc: esc, IC: IC, MOTIVE: MOTIVE,
    cos: cos, istoric: istoric, categorii: categorii, favorite: favorite,
    context: context, scor: scor, greutati: G, generice: GENERICE,
    cardHTML: cardHTML, pune: pune, pastila: pastila, vedereJSON: vedereJSON,
    rezerva: rezerva, eRezervat: eRezervat, marcheazaPagina: marcheazaPagina,
    respinse: respinse, respinge: respinge,
    handleDinUrl: handleDinUrl,

    /* Blocul principal cheama `hubTerminat()` cand si-a ales produsele; rafturile de mai jos
       asteapta `hubGata` inainte sa rezerve, ca sa nu ia ele cardul din cos. */
    hubGata: hubGata,
    hubTerminat: function () { rezolvaHub('gata'); },

    /* Ruleaza o functie cand elementul se apropie de ecran. Recomandarile de jos nu au
       de ce sa consume retea cat timp omul se uita la hero.

       ⚠️ IntersectionObserver NU e singura cale, si nu din exces de prudenta: el livreaza
       observatiile in pasul de randare al browserului. Daca fila nu se picteaza — fila de
       fundal, fereastra minimizata, un panou care nu compoziteaza (exact ce s-a intamplat
       la proba din 2026-08-12) — callback-ul NU vine niciodata si sectiunea ramane pe
       rezerva, fara nicio eroare in consola. De aceea sunt trei declansatoare, primul
       care ajunge castiga:
         1. IntersectionObserver (calea normala, cea mai eficienta);
         2. prima derulare care aduce elementul la mai putin de 3 ecrane distanta;
         3. o plasa de siguranta la 6 secunde.
       Toate trec prin `odata()`, deci functia ruleaza exact o data. */
    candeApare: function (el, fn) {
      var rulat = false;
      function odata() {
        if (rulat) return;
        rulat = true;
        try { if (o) o.disconnect(); } catch (e) {}
        window.removeEventListener('scroll', laDerulare);
        clearTimeout(cronometru);
        fn();
      }
      function laDerulare() {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 3) odata();
      }

      var o = null;
      if ('IntersectionObserver' in window) {
        o = new IntersectionObserver(function (intrari) {
          for (var i = 0; i < intrari.length; i++) {
            if (intrari[i].isIntersecting) { odata(); return; }
          }
        }, { rootMargin: '320px 0px' });
        o.observe(el);
      }
      window.addEventListener('scroll', laDerulare, { passive: true });
      var cronometru = setTimeout(odata, 6000);
    },

    /* Acelasi motiv ca mai sus: `requestAnimationFrame` nu se executa daca pagina nu se
       picteaza. Pentru pornirea unei animatii, rAF e corect; dar trebuie sa existe si o
       cale care ajunge la valoarea finala chiar daca rAF nu vine niciodata. */
    laUrmatorulCadru: function (fn) {
      var facut = false;
      function o() { if (facut) return; facut = true; fn(); }
      if (typeof requestAnimationFrame === 'function') requestAnimationFrame(o);
      setTimeout(o, 60);
    }
  };

  /* Cerem coșul o dată, la pornire: `marcheazaPagina()` e sincron și are nevoie de el ca să
     nu recomande ce e deja în coș. E aceeași cerere pe care oricum o făceau consumatorii. */
  cos();

  emite('at-perso:gata');
})();
